import { type SVGProps } from "react"
import { css } from "@octopus-energy/coral-design/css"

const greenHousesClass = css({
    "& g.light-gradient": {
        animation: "OEFRLightGradient 2s infinite",
    },
})

export function GreenHouses(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={230}
            height={114}
            fill="none"
            className={greenHousesClass}
            {...props}
        >
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__a)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M8.005 30 0 36.965v15.046h16.01V36.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303H7.47a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153H5.29a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.66.66 0 0 1 .127.386v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__b)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M8.005 0 0 6.965v15.046h16.01V6.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303H7.47a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H5.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__c)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M102.005 30 94 36.965v15.046h16.01V36.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089q.145.089.226.24c.054.1.081.212.078.325a.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__d)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M126.005 30 118 36.965v15.046h16.01V36.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089q.144.089.226.24c.054.1.081.212.078.325a.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__e)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M150.005 30 142 36.965v15.046h16.01V36.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089q.144.089.226.24c.054.1.081.212.078.325a.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__f)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M174.005 30 166 36.965v15.046h16.01V36.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089.645.645 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__g)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M198.005 30 190 36.965v15.046h16.01V36.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089.645.645 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__h)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M222.005 30 214 36.965v15.046h16.01V36.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089.645.645 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__i)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M102.005 0 94 6.965v15.046h16.01V6.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.232.66.66 0 0 1 .127.385v3.152h1.561a.6.6 0 0 1 .312.089q.145.089.226.24c.054.1.081.212.078.325a.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__j)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M126.005 0 118 6.965v15.046h16.01V6.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.6.6 0 0 1-.306-.092.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.232.66.66 0 0 1 .127.385v3.152h1.561a.6.6 0 0 1 .312.089q.144.089.226.24c.054.1.081.212.078.325a.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__k)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M150.005 0 142 6.965v15.046h16.01V6.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.6.6 0 0 1-.306-.092.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.232.66.66 0 0 1 .127.385v3.152h1.561a.6.6 0 0 1 .312.089q.144.089.226.24c.054.1.081.212.078.325a.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__l)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M174.005 0 166 6.965v15.046h16.01V6.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.6.6 0 0 1-.306-.092.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.232.66.66 0 0 1 .127.385v3.152h1.561a.6.6 0 0 1 .312.089.645.645 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__m)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M198.005 0 190 6.965v15.046h16.01V6.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.6.6 0 0 1-.306-.092.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.232.66.66 0 0 1 .127.385v3.152h1.561a.6.6 0 0 1 .312.089.645.645 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__n)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M222.005 0 214 6.965v15.046h16.01V6.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.6.6 0 0 1-.306-.092.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.232.66.66 0 0 1 .127.385v3.152h1.561a.6.6 0 0 1 .312.089.645.645 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__o)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M8.005 61 0 67.965v15.046h16.01V67.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.657-.765 1.364c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303H7.47a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153H5.29a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.66.66 0 0 1 .127.386v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__p)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M8.005 92 0 98.965v15.046h16.01V98.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H5.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.67.67 0 0 1 .127.386v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__q)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M102.005 61 94 67.965v15.046h16.01V67.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.657-.765 1.364c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089q.145.089.226.24c.054.1.081.212.078.325a.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__r)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M102.005 92 94 98.965v15.046h16.01V98.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.614.614 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561c.11.001.218.031.312.089a.643.643 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__s)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M126.005 61 118 67.965v15.046h16.01V67.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.657-.765 1.364c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089q.144.089.226.24c.054.1.081.212.078.325a.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__t)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M126.005 92 118 98.965v15.046h16.01V98.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.614.614 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.62.62 0 0 1-.529-.327.67.67 0 0 1-.005-.638c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561c.11.001.218.031.312.089a.643.643 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__u)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M150.005 61 142 67.965v15.046h16.01V67.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.657-.765 1.364c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089q.144.089.226.24c.054.1.081.212.078.325a.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__v)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M150.005 92 142 98.965v15.046h16.01V98.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.614.614 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.62.62 0 0 1-.529-.327.67.67 0 0 1-.005-.638c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561c.11.001.218.031.312.089a.643.643 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__w)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M174.005 61 166 67.965v15.046h16.01V67.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.657-.765 1.364c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089.645.645 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__x)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M174.005 92 166 98.965v15.046h16.01V98.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.614.614 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.62.62 0 0 1-.529-.327.67.67 0 0 1-.005-.638c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561c.11.001.218.031.312.089a.643.643 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__y)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M198.005 61 190 67.965v15.046h16.01V67.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.657-.765 1.364c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089.645.645 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__z)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M198.005 92 190 98.965v15.046h16.01V98.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.614.614 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.62.62 0 0 1-.529-.327.67.67 0 0 1-.005-.638c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561c.11.001.218.031.312.089a.643.643 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__A)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M222.005 61 214 67.965v15.046h16.01V67.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.657-.765 1.364c-.115.184-.22.38-.325.564a.602.602 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153h-1.562a.6.6 0 0 1-.306-.091.654.654 0 0 1-.306-.553.7.7 0 0 1 .078-.32c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561a.6.6 0 0 1 .312.089.645.645 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__B)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M222.005 92 214 98.965v15.046h16.01V98.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.614.614 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152h-1.562a.62.62 0 0 1-.529-.327.67.67 0 0 1-.005-.638c.011 0 .011 0 .011-.01l.398-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033.63.63 0 0 1 .324.231.66.66 0 0 1 .127.386v3.152h1.561c.11.001.218.031.312.089a.643.643 0 0 1 .304.565.65.65 0 0 1-.092.321"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__C)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M31.505 30 24 36.965v15.046h15.01V36.965zm3.035 12.381c-.118.238-.245.466-.373.704l-.756 1.42-.885 1.656-.717 1.365c-.108.184-.206.38-.304.564a.6.6 0 0 1-.162.197.55.55 0 0 1-.221.106h-.118a.44.44 0 0 1-.305-.087.63.63 0 0 1-.275-.541v-3.153h-1.463a.55.55 0 0 1-.287-.091.6.6 0 0 1-.21-.235.7.7 0 0 1-.004-.638c.01 0 .01 0 .01-.01l.373-.694c.245-.476.5-.953.756-1.419l.875-1.657.726-1.365.305-.563a.63.63 0 0 1 .285-.27.56.56 0 0 1 .373-.033c.121.04.228.12.304.231a.7.7 0 0 1 .119.386v3.152h1.463a.54.54 0 0 1 .293.089q.135.089.212.24a.69.69 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__D)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M31.505 0 24 6.965v15.046h15.01V6.965zm3.035 12.381c-.118.238-.245.466-.373.704l-.756 1.42-.885 1.656-.717 1.365c-.108.184-.206.38-.304.564a.6.6 0 0 1-.162.197.55.55 0 0 1-.221.106h-.118a.44.44 0 0 1-.305-.087.63.63 0 0 1-.275-.541v-3.152h-1.463a.55.55 0 0 1-.287-.092.6.6 0 0 1-.21-.235.7.7 0 0 1-.004-.638c.01 0 .01 0 .01-.01l.373-.694c.245-.476.5-.953.756-1.419l.875-1.657.726-1.365.305-.563a.63.63 0 0 1 .285-.27.56.56 0 0 1 .373-.033c.121.04.228.12.304.232a.7.7 0 0 1 .119.385v3.152h1.463a.54.54 0 0 1 .293.089q.135.089.212.24a.69.69 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__E)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M31.505 61 24 67.965v15.046h15.01V67.965zm3.035 12.381c-.118.238-.245.466-.373.704l-.756 1.42-.885 1.657-.717 1.364c-.108.184-.206.38-.304.564a.6.6 0 0 1-.162.197.55.55 0 0 1-.221.106h-.118a.44.44 0 0 1-.305-.087.63.63 0 0 1-.275-.541v-3.153h-1.463a.55.55 0 0 1-.287-.091.6.6 0 0 1-.21-.235.7.7 0 0 1-.004-.638c.01 0 .01 0 .01-.01l.373-.694c.245-.476.5-.953.756-1.419l.875-1.657.726-1.365.305-.563a.63.63 0 0 1 .285-.27.56.56 0 0 1 .373-.033c.121.04.228.12.304.231a.7.7 0 0 1 .119.386v3.152h1.463a.54.54 0 0 1 .293.089q.135.089.212.24a.69.69 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__F)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M31.505 92 24 98.965v15.046h15.01V98.965zm3.035 12.381c-.118.238-.245.466-.373.704l-.756 1.419-.885 1.657-.717 1.365c-.108.184-.206.379-.304.564a.6.6 0 0 1-.162.197.56.56 0 0 1-.221.106h-.118a.44.44 0 0 1-.305-.087.63.63 0 0 1-.275-.541v-3.152h-1.463a.55.55 0 0 1-.287-.092.6.6 0 0 1-.21-.235.7.7 0 0 1-.004-.638c.01 0 .01 0 .01-.01l.373-.694c.245-.476.5-.953.756-1.419l.875-1.657.726-1.365.305-.563a.63.63 0 0 1 .285-.27.56.56 0 0 1 .373-.033c.121.04.228.12.304.231a.7.7 0 0 1 .119.386v3.152h1.463a.54.54 0 0 1 .293.089.6.6 0 0 1 .212.24.69.69 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__G)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M54.505 30 47 36.965v15.046h15.01V36.965zm3.035 12.381c-.118.238-.245.466-.373.704l-.756 1.42-.885 1.656-.717 1.365c-.108.184-.206.38-.304.564a.6.6 0 0 1-.162.197.55.55 0 0 1-.221.106h-.118a.44.44 0 0 1-.305-.087.63.63 0 0 1-.275-.541v-3.153h-1.463a.55.55 0 0 1-.287-.091.6.6 0 0 1-.21-.235.7.7 0 0 1-.004-.638c.01 0 .01 0 .01-.01l.373-.694c.245-.476.5-.953.756-1.419l.875-1.657.726-1.365.305-.563a.63.63 0 0 1 .284-.27.56.56 0 0 1 .374-.033c.121.04.228.12.304.231a.7.7 0 0 1 .119.386v3.152h1.463a.54.54 0 0 1 .293.089q.135.089.212.24a.69.69 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__H)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M54.505 0 47 6.965v15.046h15.01V6.965zm3.035 12.381c-.118.238-.245.466-.373.704l-.756 1.42-.885 1.656-.717 1.365c-.108.184-.206.38-.304.564a.6.6 0 0 1-.162.197.55.55 0 0 1-.221.106h-.118a.44.44 0 0 1-.305-.087.63.63 0 0 1-.275-.541v-3.152h-1.463a.55.55 0 0 1-.287-.092.6.6 0 0 1-.21-.235.7.7 0 0 1-.004-.638c.01 0 .01 0 .01-.01l.373-.694c.245-.476.5-.953.756-1.419l.875-1.657.726-1.365.305-.563a.63.63 0 0 1 .284-.27.56.56 0 0 1 .374-.033c.121.04.228.12.304.232a.7.7 0 0 1 .119.385v3.152h1.463a.54.54 0 0 1 .293.089q.135.089.212.24a.69.69 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__I)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M54.505 61 47 67.965v15.046h15.01V67.965zm3.035 12.381c-.118.238-.245.466-.373.704l-.756 1.42-.885 1.657-.717 1.364c-.108.184-.206.38-.304.564a.6.6 0 0 1-.162.197.55.55 0 0 1-.221.106h-.118a.44.44 0 0 1-.305-.087.63.63 0 0 1-.275-.541v-3.153h-1.463a.55.55 0 0 1-.287-.091.6.6 0 0 1-.21-.235.7.7 0 0 1-.004-.638c.01 0 .01 0 .01-.01l.373-.694c.245-.476.5-.953.756-1.419l.875-1.657.726-1.365.305-.563a.63.63 0 0 1 .284-.27.56.56 0 0 1 .374-.033c.121.04.228.12.304.231a.7.7 0 0 1 .119.386v3.152h1.463a.54.54 0 0 1 .293.089q.135.089.212.24a.69.69 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__J)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M54.505 92 47 98.965v15.046h15.01V98.965zm3.035 12.381c-.118.238-.245.466-.373.704l-.756 1.419-.885 1.657-.717 1.365c-.108.184-.206.379-.304.564a.6.6 0 0 1-.162.197.56.56 0 0 1-.221.106h-.118a.44.44 0 0 1-.305-.087.63.63 0 0 1-.275-.541v-3.152h-1.463a.55.55 0 0 1-.287-.092.6.6 0 0 1-.21-.235.7.7 0 0 1-.004-.638c.01 0 .01 0 .01-.01l.373-.694c.245-.476.5-.953.756-1.419l.875-1.657.726-1.365.305-.563a.63.63 0 0 1 .284-.27.56.56 0 0 1 .374-.033c.121.04.228.12.304.231a.7.7 0 0 1 .119.386v3.152h1.463a.54.54 0 0 1 .293.089.6.6 0 0 1 .212.24.69.69 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__K)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M78.005 30 70 36.965v15.046h16.01V36.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153H75.29a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.66.66 0 0 1 .127.386v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__L)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M78.005 0 70 6.965v15.046h16.01V6.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H75.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__M)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M78.005 61 70 67.965v15.046h16.01V67.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.657-.765 1.364c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153H75.29a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.66.66 0 0 1 .127.386v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                />
            </g>
            <g
                className="light-gradient"
                clipPath="url(#green-houses_svg__N)"
                opacity={0.8}
            >
                <path
                    fill="#18F0B8"
                    d="M78.005 92 70 98.965v15.046h16.01V98.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H75.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.67.67 0 0 1 .127.386v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                />
            </g>
        </svg>
    )
}
